import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
type PlanId = 'estandar' | 'completa';
interface Plan {
  id: PlanId;
  name: string;
  tagline: string;
  oldPrice: string;
  price: string;
  url: string;
  features: string[];
  badge?: string;
  recommended?: boolean;
}
const PLANS: Plan[] = [{
  id: 'estandar',
  name: 'Kit Consultorio en Orden',
  tagline: '6 tomos + 3 bonos estratégicos',
  oldPrice: '$34.990',
  price: '19.990',
  url: 'https://checkout.solucionesya.shop/cart/48854530687224:1',
  features: ['6 tomos del flujo clínico completo', '3 bonos estratégicos incluidos', 'Acceso inmediato · Pago único']
}, {
  id: 'completa',
  name: 'Edición Completa',
  tagline: 'Todo lo anterior + gestión y economía',
  oldPrice: '$43.990',
  price: '27.990',
  url: 'https://checkout.solucionesya.shop/cart/48854550053112:1',
  badge: '⭐ MÁS ELEGIDA',
  recommended: true,
  features: ['Todo el Kit Consultorio en Orden', 'Tomo 7 — Gestión del equipo de trabajo', 'Tomo 8 — Economía del consultorio', 'Planilla de ingresos e indicadores clave']
}];
interface PlanSelectorProps {
  showFeatures?: boolean;
}
export function PlanSelector({
  showFeatures = true
}: PlanSelectorProps) {
  // Higher-priced "completa" plan is preselected by default
  const [selected, setSelected] = useState<PlanId>('completa');
  const activePlan = PLANS.find(p => p.id === selected)!;
  return <div className="mx-auto max-w-[760px]" data-id="element-187">
      {/* Horizontal stacked rows */}
      <div className="flex flex-col gap-3" data-id="element-188">
        {PLANS.map(plan => {
        const isSelected = selected === plan.id;
        return <button key={plan.id} type="button" onClick={() => setSelected(plan.id)} aria-pressed={isSelected} className={`relative flex w-full items-center gap-3 rounded-xl border-2 p-4 text-left transition-all sm:gap-4 sm:p-5 ${isSelected ? 'border-gold bg-gold/10 shadow-[0_8px_32px_rgba(244,162,20,0.22)]' : 'border-white/12 bg-white/5 hover:border-white/30'}`} data-id="element-189">
              {/* Radio indicator */}
              <span aria-hidden="true" className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 transition-all ${isSelected ? 'border-gold bg-gold' : 'border-white/40'}`} data-id="element-190">
                {isSelected && <CheckIcon className="h-3.5 w-3.5 text-navy" strokeWidth={3} data-id="element-191" />}
              </span>

              {/* Left: name + tagline (+ features) */}
              <div className="min-w-0 flex-1" data-id="element-192">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-193">
                  <p className="font-montserrat text-[13px] font-black uppercase tracking-[0.5px] text-white sm:text-[14px]" data-id="element-194">
                    {plan.name}
                  </p>
                  {plan.badge && <span className="rounded-full bg-gold px-2 py-0.5 font-montserrat text-[9px] font-black tracking-[0.5px] text-navy" data-id="element-195">
                      {plan.badge}
                    </span>}
                </div>
                <p className="mt-0.5 text-[11px] leading-snug text-white/55 sm:text-[12px]" data-id="element-196">
                  {plan.tagline}
                </p>

                {showFeatures && <ul className="mt-2 hidden flex-wrap gap-x-3 gap-y-1 sm:flex" data-id="element-197">
                    {plan.features.map((feat, i) => <li key={i} className="flex items-center gap-1 text-[11px] text-white/65" data-id="element-198">
                        <CheckIcon className="h-3 w-3 shrink-0 text-gold" strokeWidth={3} data-id="element-199" />
                        {feat}
                      </li>)}
                  </ul>}
              </div>

              {/* Right: price */}
              <div className="shrink-0 text-right" data-id="element-200">
                <p className="font-montserrat text-[11px] text-white/35 line-through" data-id="element-201">
                  {plan.oldPrice}
                </p>
                <p className="font-bebas text-[32px] leading-none text-white sm:text-[40px]" data-id="element-202">
                  <span className="mr-0.5 align-super font-montserrat text-[13px] font-bold sm:text-[15px]" data-id="element-203">
                    $
                  </span>
                  {plan.price}
                </p>
              </div>
            </button>;
      })}
      </div>

      {/* Shared purchase button */}
      <a href={activePlan.url} className="mt-5 block w-full rounded-lg bg-btn-red px-5 py-4 text-center font-montserrat text-[15px] font-black uppercase tracking-[0.5px] text-white shadow-[0_6px_24px_rgba(230,57,70,0.4)] transition-all hover:-translate-y-0.5 hover:shadow-[0_10px_32px_rgba(230,57,70,0.5)]" data-id="element-204">
        {selected === 'completa' ? 'SÍ, QUIERO LA EDICIÓN COMPLETA →' : 'QUIERO EL KIT — $19.990 →'}
      </a>
      <p className="mt-3 text-center font-montserrat text-[11px] text-white/45" data-id="element-205">
        Estás comprando:{' '}
        <span className="font-bold text-gold" data-id="element-206">{activePlan.name}</span> · $
        {activePlan.price}
      </p>
    </div>;
}